/* Presentation enhancements scoped to the homepage. */
(() => {
  if (!document.documentElement.hasAttribute('data-evolve-visual')) return;

  const addDetailsLinks = () => {
    document.querySelectorAll('.v2-card-wrapper, .v2-fc-card-wrapper').forEach(card => {
      if (card.querySelector('.ev-card-details')) return;
      const title = card.querySelector('.card-info .x-card-title');
      const price = card.querySelector('.card-info .x-card-price');
      if (!title || !price) return;

      const link = document.createElement('a');
      link.className = 'ev-card-details';
      link.href = title.href;
      link.setAttribute('aria-label', `View details for ${title.title || title.textContent.trim()}`);
      link.append(document.createTextNode('View details'));
      const arrow = document.createElement('span');
      arrow.textContent = '\u2192';
      arrow.setAttribute('aria-hidden', 'true');
      link.append(arrow);
      price.after(link);
    });
  };

  const prepareImageFades = () => {
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    const modelPhotos = new Map();
    const isModelPhoto = alt => /\bmodel\s+(?:shot|wearing)\b|\b(?:worn by|on[- ]model)\b/i.test(alt || '');
    const copyPhoto = (source, className) => {
      const image = document.createElement('img');
      image.className = className;
      image.alt = '';
      image.decoding = 'async';
      // Copy only image attributes, without the theme's hover classes or handlers.
      ['sizes', 'srcset', 'src', 'width', 'height'].forEach(name => {
        const value = source.getAttribute(name);
        if (value) image.setAttribute(name, value);
      });
      return image;
    };
    const findModelPhoto = async imageLink => {
      const selectedCard = imageLink.closest('[data-ev-model-src]');
      if (selectedCard && isModelPhoto(selectedCard.dataset.evModelAlt)) {
        const selected = document.createElement('img');
        const url = new URL(selectedCard.dataset.evModelSrc, imageLink.href);
        url.searchParams.set('width', '750');
        selected.src = url.href;
        selected.alt = selectedCard.dataset.evModelAlt;
        selected.width = 750;
        selected.height = 750;
        return selected;
      }
      const existing = imageLink.querySelector('.image-second-hover');
      if (existing && isModelPhoto(existing.alt)) return existing;
      const handle = new URL(imageLink.href).pathname.match(/\/products\/([^/]+)/)?.[1];
      if (!handle) return null;
      if (!modelPhotos.has(handle)) {
        const root = window.Shopify?.routes?.root || '/';
        modelPhotos.set(handle, fetch(`${root}products/${handle}.js`)
          .then(response => {
            if (!response.ok) throw new Error('Product images unavailable');
            return response.json();
          })
          .then(product => product.media?.find(item => item.media_type === 'image' && isModelPhoto(item.alt)))
          .catch(() => null));
      }
      const photo = await modelPhotos.get(handle);
      if (!photo?.src) return null;
      const source = document.createElement('img');
      source.alt = photo.alt;
      const url = new URL(photo.src, imageLink.href);
      url.searchParams.set('width', '750');
      source.src = url.href;
      source.width = photo.preview_image?.width || 750;
      source.height = photo.preview_image?.height || 750;
      return source;
    };
    const prepare = async imageLink => {
      if (imageLink.querySelector('.ev-card-media')) return;
      const primary = imageLink.querySelector('.image-first-hover');
      if (!primary) return;

      const media = document.createElement('span');
      media.className = 'ev-card-media';
      media.setAttribute('aria-hidden', 'true');
      const base = copyPhoto(primary, 'ev-card-photo');
      media.append(base);
      imageLink.append(media);
      try {
        await base.decode();
        imageLink.classList.add('ev-image-ready');
      } catch {
        media.remove();
        return;
      }
      const model = await findModelPhoto(imageLink);
      if (!model) return; // No verified model shot: keep the primary photo still.
      const alternate = copyPhoto(model, 'ev-card-photo ev-card-photo--alternate');
      alternate.dataset.photoDescription = model.alt;
      media.append(alternate);
      try {
        await alternate.decode();
        // Paint the transparent layer before enabling hover, even if already hovered.
        requestAnimationFrame(() => requestAnimationFrame(() => {
          imageLink.classList.add('ev-model-ready');
        }));
      } catch {
        alternate.remove();
      }
    };
    const observer = 'IntersectionObserver' in window
      ? new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            prepare(entry.target);
          });
        }, { rootMargin: '300px' })
      : null;

    const observeCards = () => {
      if (!finePointer.matches) return;
      document.querySelectorAll('.v2-card-wrapper, .v2-fc-card-wrapper').forEach(card => {
        const imageLink = card.querySelector('.image-first-hover')?.closest('.x-labels-data');
        if (!imageLink) return;
        imageLink.classList.add('ev-image-swap');
        if (observer) observer.observe(imageLink);
        else prepare(imageLink);
      });
    };
    observeCards();
    finePointer.addEventListener('change', observeCards);
  };

  const initialize = () => {
    addDetailsLinks();
    prepareImageFades();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
